<template>
  <div class="h-full">
    <el-menu
      class="el-menu-vertical-demo h-full"
      background-color="#1B1E24"
      text-color="#8B91A0"
      :collapse="collapseBoolean"
      router
      :default-active="activeLink"
    >
      <!-- Menu Item for Logo -->
      <el-menu-item class="icono" @click="clearFilters">
        <a v-if="!collapseBoolean">
          <img
            src="@/assets/logo.png"
            class="logo"
            alt
            data-src="@/assets/logo.png"
            data-src-retina="@/assets/logo2x.png"
            height="30"
          />
        </a>
        <a v-else>
          <img
            src=""
            class="logo"
            alt
            data-src="@/assets/solo-logo.png"
            @click="clearFilters"
          />
        </a>
      </el-menu-item>

      <el-menu-item
        v-for="item in menu"
        :key="item.title"
        :index="item.href ? item.href : 'undefined'"
      >
        <div>
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </div>
      </el-menu-item>

      <!--subMenuFieldSite -->
      <el-submenu
        v-for="item in subMenuFieldSite"
        :key="item.title"
        :index="item.href ? item.href : 'undefinded'"
      >
        <template slot="title">
          <div class="elMenu">
            <i :class="item.icon"></i>
            <span class="iconSmall">{{ item.title }}</span>
          </div>
        </template>

        <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
          <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
            <i :class="subitem.icon"></i>
            {{ subitem.title }}
          </el-menu-item>
        </div>
      </el-submenu>

      <!-- subMenuField -->
      <el-submenu
        v-for="item in subMenuField"
        :key="item.title"
        :index="item.href ? item.href : 'undefined'"
      >
        <template slot="title">
          <div class="elMenu">
            <i :class="item.icon"></i>
            <span class="iconSmall">{{ item.title }}</span>
          </div>
        </template>

        <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
          <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
            <i :class="subitem.icon"></i>
            {{ subitem.title }}
          </el-menu-item>
        </div>
      </el-submenu>

      <!-- subMenuParameters -->
      <el-submenu
        v-for="item in subMenuParameters"
        :key="item.title"
        :index="item.href ? item.href : 'undefined'"
      >
        <template slot="title">
          <div class="elMenu">
            <i :class="item.icon"></i>
            <span class="iconSmall">{{ item.title }}</span>
          </div>
        </template>

        <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
          <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
            <i :class="subitem.icon"></i>
            {{ subitem.title }}
          </el-menu-item>
        </div>
      </el-submenu>

      <!-- subMenuConfiguration -->
      <el-submenu
        v-for="item in subMenuConfiguration"
        :key="item.title"
        :index="item.href ? item.href : 'undefined'"
      >
        <template slot="title">
          <div class="elMenu">
            <i :class="item.icon"></i>
            <span class="iconSmall">{{ item.title }}</span>
          </div>
        </template>

        <div v-for="subitem in item.subMenuTwo" :key="subitem.title">
          <el-menu-item :index="subitem.href ? subitem.href : 'undefined'">
            <i :class="subitem.icon"></i>
            {{ subitem.title }}
          </el-menu-item>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "navMenu",
  created: function() {
    var vm = this;
    vm.activeLink = vm.$route.path;
  },
  watch: {
    "$route.path": function() {
      var vm = this;
      vm.activeLink = vm.$route.path;
    },
  },
  components: {},
  props: {
    menu: {
      type: Array,
      required: true,
    },
    subMenu: {
      type: Array,
      required: true,
    },
    subMenuFieldSite: {
      type: Array,
      required: false,
    },
    subMenuField: {
      type: Array,
      required: false,
    },
    subMenuParameters: {
      type: Array,
      required: false,
    },
    subMenuConfiguration: {
      type: Array,
      required: false,
    },
    collapseBoolean: {
      type: Boolean,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      activeLink: null,
    };
  },
  methods: {
    clearFilters() {
      this.$emit("clearFilters");
    },
  },
};
</script>

<style scoped>
i {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: stretch;
}
.el-menu-item i,
.el-submenu i,
.elMenu i {
  margin-right: 5px;
  width: 20px;
  font-size: 15px;
  border: #e6e6e6;
}
.el-menu-item span,
.el-submenu span {
  padding-right: 70px;
}
.icono {
  background-color: #e6e6e6 !important;
  padding: 0px !important;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
}
a:hover {
  text-decoration: none !important;
  color: none !important;
}

/* allow menu entries to linebreak */
li {
  /* set item height dynamically */
  height: unset !important;
  padding-top: 8px !important;
  line-height: 1.7rem !important;

  /* allow linebreaks */
  white-space: break-spaces;
  background-color: #1B1E24;
}

.icono {
  height: 48px !important;
  align-items: center;
}

.el-menu-vertical-demo {
  width: 100% !important;
}
</style>
